var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "report-filter-tool" }, [
    _c(
      "div",
      { staticClass: "date-filter" },
      [
        _c(
          "SupsisButton",
          { attrs: { ghost: "", small: "" }, on: { click: _vm.prevDate } },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("chevron_left")])]
        ),
        _vm._v(" "),
        _c("datetime", {
          attrs: {
            value: _vm.filters.startDate,
            placeholder: _vm.$t("message.startDate"),
            auto: "",
            "input-class": "form-control rounded-0",
            type: "datetime",
          },
          on: { input: _vm.changeStartDate },
        }),
        _vm._v(" "),
        _c("datetime", {
          attrs: {
            "max-datetime": _vm.getMax(),
            "min-datetime": _vm.getMaxMinDate(),
            placeholder: _vm.$t("message.endDate"),
            auto: "",
            "input-class": "form-control rounded-0",
            type: "datetime",
          },
          model: {
            value: _vm.filters.endDate,
            callback: function ($$v) {
              _vm.$set(_vm.filters, "endDate", $$v)
            },
            expression: "filters.endDate",
          },
        }),
        _vm._v(" "),
        _c(
          "SupsisButton",
          { attrs: { ghost: "", small: "" }, on: { click: _vm.nextDate } },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("chevron_right"),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "input-groups" }, [
      _c(
        "div",
        { staticClass: "input-group" },
        [
          _vm.filters.users.length === 0
            ? _c("md-chip", { staticClass: "md-primary" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.allRepresentatives")) +
                    "\n            "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.getSelectedUsers(), function (user) {
            return _c(
              "md-chip",
              {
                key: user._id,
                staticClass: "md-primary",
                attrs: { "md-deletable": "" },
                on: {
                  "md-delete": function ($event) {
                    return _vm.removeUser(user._id)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.capitalize(user.name)) +
                    "\n            "
                ),
              ]
            )
          }),
          _vm._v(" "),
          !_vm.autoCompleteShow &&
          _vm.users.filter(function (x) {
            return !_vm.filters.users.includes(x._id)
          }).length
            ? _c(
                "md-chip",
                {
                  staticClass: "md-accent",
                  attrs: { "md-clickable": "" },
                  on: { click: _vm.openAutoComplete },
                },
                [
                  _vm._v(
                    "\n                + " +
                      _vm._s(_vm.$t("message.addRepresentative")) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.autoCompleteShow
            ? _c(
                "md-autocomplete",
                {
                  staticClass: "ml-3",
                  staticStyle: { "margin-top": "15px" },
                  attrs: {
                    "md-fuzzy-search": true,
                    "md-open-on-focus": true,
                    "md-options": _vm.users.filter(function (x) {
                      return !_vm.filters.users.includes(x._id)
                    }),
                    autofocus: "",
                    "md-input-id": "acUsers",
                  },
                  on: { "md-selected": _vm.autoCompleteSelected },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "md-autocomplete-item",
                        fn: function (ref) {
                          var item = ref.item
                          var term = ref.term
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "font-size": "16px",
                                },
                              },
                              [
                                _c("Avatar", {
                                  staticClass: "mr-2",
                                  staticStyle: { color: "white" },
                                  attrs: { size: 40, username: item.name },
                                }),
                                _vm._v(" "),
                                _c(
                                  "md-highlight-text",
                                  { attrs: { "md-term": term } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.capitalize(item.name)) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "md-autocomplete-empty",
                        fn: function (ref) {
                          var term = ref.term
                          return [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("message.noRePresentativeFound")
                                ) +
                                "\n                "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    256433726
                  ),
                  model: {
                    value: _vm.autoCompleteValue,
                    callback: function ($$v) {
                      _vm.autoCompleteValue = $$v
                    },
                    expression: "autoCompleteValue",
                  },
                },
                [_c("label", [_vm._v(_vm._s(_vm.$t("message.selectRep")))])]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group" },
        [
          _vm._l(_vm.getSelectedChannels(), function (channel) {
            return _c(
              "md-chip",
              {
                key: channel._id,
                staticClass: "md-primary",
                attrs: { "md-deletable": "" },
                on: {
                  "md-delete": function ($event) {
                    return _vm.removeChannel(channel._id)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " + _vm._s(channel.name) + "\n            "
                ),
              ]
            )
          }),
          _vm._v(" "),
          _vm.filters.channels.length === 0
            ? _c("md-chip", { staticClass: "md-primary" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("report.allChannels")) +
                    "\n            "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "md-chip",
            {
              staticClass: "md-accent",
              staticStyle: { background: "#3f8646 !important" },
              attrs: { "md-clickable": "" },
              on: { click: _vm.openAutoCompleteChannel },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("whatsappChannel.addChannel")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.autoCompleteShowChannel
            ? _c(
                "md-autocomplete",
                {
                  staticClass: "ml-3",
                  attrs: {
                    "md-fuzzy-search": true,
                    "md-open-on-focus": true,
                    "md-options": _vm.channels.filter(function (x) {
                      return !_vm.filters.channels.includes(x._id)
                    }),
                    "md-input-id": "acChannels",
                  },
                  on: { "md-selected": _vm.autoCompleteSelectedChannel },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "md-autocomplete-item",
                        fn: function (ref) {
                          var item = ref.item
                          var term = ref.term
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "font-size": "16px",
                                },
                              },
                              [
                                _c(
                                  "md-highlight-text",
                                  { attrs: { "md-term": term } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(item.name) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "md-autocomplete-empty",
                        fn: function (ref) {
                          var term = ref.term
                          return [_vm._v(" Kanal Bulunamadı")]
                        },
                      },
                    ],
                    null,
                    false,
                    477287533
                  ),
                  model: {
                    value: _vm.channelName,
                    callback: function ($$v) {
                      _vm.channelName = $$v
                    },
                    expression: "channelName",
                  },
                },
                [_c("label", [_vm._v(_vm._s(_vm.$t("report.selectaChannel")))])]
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }